define('views/modules/dashboard/goal/list/goal-list-item',[
    // Libs
    'underscore', 'backbone', 'mustache', 'moment', 'utils',
    // services
    'services/i18n',
    'services/toastr-service',
    // models & collections
    'collections/calendar/items',
    'collections/calendar/days',
    // views
    'views/parts/chart/double-doughnut-chart',
    'views/modules/calendar/calendar/calendar-component/item/calendar-item-list',
    'views/modules/goal/story/goal-story-list',
    // templates
    'text!templates/modules/dashboard/goal/list/goal-list-item.html'
], function(
    // Libs
    _, Backbone, Mustache, moment, U,
    // services
    i18n,
    ToastrService,
    // models & collections
    CCalendarItems,
    CCalendarDays,
    // views
    VDoubleDoughnutChart,
    VCalendarItemList,
    VGoalStoryList,
    // templates
    TGoalListItem
) {

    var VGoalListItem = Backbone.View.extend({
        template: TGoalListItem,
        className: 'ucolfix goal-list-item',

        regions: {
            chart: ".chart",
            story: ".goal-story",
            noStory: ".no-goal-story",
        },

        events: {
          'click a.forbidden': "onInsertGoalItemClick"
        },

        initialize: function(opt) {
            opt = this.options = _.extend({}, opt);

            _.extend(this, {
                group: opt.group,
                profile: opt.profile,
                role: opt.role
            });

            var collection = this.collection = new CCalendarDays(null, {
                    date: moment().subtract(2, 'months'),
                    count: moment().diff(moment().subtract(2, 'months'), 'days') + 1,
                    user: opt.profile.id,
                    type: this.model.getCalendarItemType()
                }),
                items = this.items = new CCalendarItems(),
                model = this.model,
                view = this.view = {
                    chart: new VDoubleDoughnutChart({
                        model: model,
                        goalClass: model.getProgressColor()
                    }),
                    story: new VGoalStoryList({
                        collection: items,
                        goal: this.model
                    }),
                },
                url = this.url = _.clone(opt.url);


            this.setNewCalendarItemUrl();

            this.listenTo(collection, { 'sync': this.onCollectionSync });
        },

        render: function() {

            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext(
                _.extend({
                    memberEntry: this.model.get('customData_memberEntry')
                }, this.options))));

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.assign(view.chart, zone.$chart)
                .assign(view.story, zone.$story);


            this.collection.fetch();

            return this;
        },

        onCollectionSync: function(collection) {
            var model = this.model,
                items = collection.getAllItems();

            items = model.isCustom() ? this.filterCustomDataItem(items) : items;
            this.items.reset(items.slice(0, 4));

            if (items.length) {
                this.zone.$noStory.hide();
            } else {
                this.zone.$noStory.show();
            }

            this.changeGoalItemsOrder();
        },

        changeGoalItemsOrder: function() {
          var $elements = this.$el.find('.goal-story .urowfix').toArray().reverse();
          this.$el.find('.goal-story').empty();
          this.$el.find('.goal-story').append($elements);
        },

        filterCustomDataItem: function(items) {
            return _.filter(items, function(item) {
                return item.get('customData') === this.model.get('customData_id');
            }, this);
        },

        setNewCalendarItemUrl: function() {
            var url = '#/' + this.url.dashboard + 'calendar/{{date}}/{{itemType}}/';
            var context = this.getNewCalendarItemContext();

            if (this.model.getType() === "custom") {
                url = '#/' + this.url.dashboard + 'calendar/{{date}}/{{itemType}}?itemId={{itemId}}';
                context.itemId = this.model.get('customData_id');
            }

            this.options.newItemUrl = Mustache.render(url, context);
        },

        getNewCalendarItemContext: function() {
            return {
                date: moment().format('YYYY-MM-DD'),
                itemType: this.model.getCalendarItemType(),
                groupId: this.group.id,
                userId: this.profile.id,
            };
        },

        onInsertGoalItemClick: function(e) {
            e.preventDefault();
            ToastrService.error('messages:only-supervisor-log-data');
        }

    });

    return VGoalListItem;
});

